export const IS_MAC =
  typeof navigator !== 'undefined' && /Mac|iPhone|iPad|iPod/i.test(navigator.platform);

export const MOD_LABEL = IS_MAC ? '⌘' : 'Ctrl';

export const SIDEBAR_SHORTCUT_LABEL = IS_MAC ? '⌘\\' : 'Ctrl \\';

/* ── iOS / iOS-Safari 감지 ────────────────────────────────────────
 * 마이크 API (getUserMedia / SpeechRecognition) 는 iOS 에서 Safari 만 안정 지원.
 * iOS Chrome / Firefox / Edge 는 WKWebView 위에서 동작하지만 마이크 권한이 호스트 앱에
 * 종속적이라 페이지 레벨 prompt 가 안 뜨거나 즉시 거부되는 경우가 흔함.
 */
function detectIos(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent;
  if (/iPad|iPhone|iPod/.test(ua)) return true;
  // iPadOS 13+ 는 Macintosh 로 가장하지만 touch 지원으로 구분.
  if (typeof document !== 'undefined' && ua.includes('Macintosh') && 'ontouchend' in document) {
    return true;
  }
  return false;
}

function detectIosSafari(): boolean {
  if (!detectIos()) return false;
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent;
  // iOS Safari 는 Safari 포함 + 다른 브라우저 식별자 (CriOS, FxiOS, EdgiOS, OPiOS, GSA) 없음.
  return /Safari/.test(ua) && !/CriOS|FxiOS|EdgiOS|OPiOS|GSA/.test(ua);
}

export const IS_IOS = detectIos();
export const IS_IOS_SAFARI = detectIosSafari();
export const IS_IOS_NON_SAFARI = IS_IOS && !IS_IOS_SAFARI;
